import { motion } from "framer-motion";

interface SeoSectionProps {
  title: string;
  children: React.ReactNode;
}

export const SeoSection = ({ title, children }: SeoSectionProps) => (
  <motion.section
    initial={{ opacity: 0, y: 15 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
  >
    <h2 className="text-lg md:text-xl font-montserrat font-bold text-primary mb-4 flex items-center gap-2">
      <span className="w-1 h-6 rounded-full bg-gradient-to-b from-brand-purple to-brand-magenta" />
      {title}
    </h2>
    <div className="text-muted-foreground leading-relaxed space-y-3">
      {children}
    </div>
  </motion.section>
);
